import { render } from "./LocationsCheck.vue?vue&type=template&id=0a6dfb70"
import script from "./LocationsCheck.vue?vue&type=script&lang=js"
export * from "./LocationsCheck.vue?vue&type=script&lang=js"

import exportComponent from "/Users/martin/www/forton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__